import React, { useState, useEffect } from 'react'
import { Tooltip } from '@material-ui/core'
import { Search } from '@material-ui/icons'
import { push } from '../../actions/router'
import { resetSearch, searchPacks } from '../../actions/search'
import {
  getParams,
  stringifyNestedQuery,
  buildDefaultQuery,
  removeEmptyFilters,
} from '../../services/search'
import { VALIDATION_PATTERNS } from '../../config'
import { StyledSearschPanel } from './styled'

export const SearchPanel = ({
  dispatch,
  match: {
    params: { groupId },
  },
  location: { pathname = '', search = '' },
}) => {
  const params = getParams(search)
  const [inputValue, setInputValue] = useState(params.keywords || '')

  useEffect(() => {
    if (!!params.keywords) {
      setInputValue(params.keywords)
    }
  }, [params.keywords])

  const clickHandler = () => {
    const encodedKeyword = encodeURIComponent(inputValue)
    const editorPortal =
      pathname.endsWith('/publish') ||
      pathname.endsWith('/search') ||
      VALIDATION_PATTERNS.PACK_PATH.test(pathname)
    if (editorPortal) {
      dispatch(resetSearch())
      if (pathname.endsWith('/search')) {
        dispatch(
          searchPacks(
            removeEmptyFilters({
              ...params,
              keywords: inputValue,
              group: groupId,
            })
          )
        )
        dispatch(
          push(
            pathname,
            stringifyNestedQuery(
              removeEmptyFilters({ ...params, keywords: inputValue })
            )
          )
        )
      } else {
        dispatch(
          push(
            `/group/${groupId}/search?${buildDefaultQuery(
              editorPortal,
              encodedKeyword
            )}`
          )
        )
      }
    } else {
      if (pathname === '/consumersearch') {
        if (params.keywords !== inputValue) {
          dispatch(
            push(
              pathname,
              stringifyNestedQuery(
                removeEmptyFilters({ ...params, keywords: inputValue })
              )
            )
          )
        }
      } else {
        dispatch(
          push(
            `/consumersearch?group=${groupId ||
              params.group}&${buildDefaultQuery(editorPortal, encodedKeyword)}`
          )
        )
      }
    }
  }
  return (
    <StyledSearschPanel>
      <div className="input-area">
        <input
          id="search-input"
          placeholder="Search for graphics..."
          className="search-input"
          onChange={(e): void => {
            setInputValue(e.target.value)
          }}
          onKeyUp={(e): void => {
            if (e.keyCode === 13) {
              clickHandler()
            }
          }}
          value={inputValue}
        />
      </div>
      <div className="action-area">
        <Tooltip title="Search">
          <button
            id="search-submit"
            className="search-button"
            onClick={clickHandler}
          >
            <Search fontSize="small" />
          </button>
        </Tooltip>
      </div>
    </StyledSearschPanel>
  )
}
